import { ScreenOrientationService } from './screen-orientation.service';

export default angular
  .module('sfMobile.services.screen-orientation', [])
  .service('screenOrientationService', ScreenOrientationService).name;
